import { Button, Card, Checkbox, Icon, TextArea } from '@scuf/common';
import React, { useState } from 'react';
import { ACTION_STATUS, ERROR_MSG_FOR_USER_RESPONSE, FEEDBACK_REASON, HAS_SCRIPT, PROFILES_API_PATHS } from '../../constants/constants';
import './FeedbackCard.scss';
import axios from '../../utils/APIUtils';
import { IFeedbackAPIModel } from '../../models/IFeedbackAPIModel';
import { checkSpecialCharacters } from 'src/utils/validationUtils';
import { getMessage } from '../../message/utils';

const FeedbackCard = (props: { onClose: Function}) => {
    const [remarks, setRemarks] = useState('');
    const [submitStatus, setSubmitStatus] = useState('idle' as ACTION_STATUS);
    const initialFeedbackStatus = { val1: false, val2: false, val3: false, val4: false, val5: false };
    const [feedback, setFeedback] = useState(initialFeedbackStatus);
    const [validationError, setValidationError] = useState<boolean>(false);
    const feedbackTitle: string = getMessage('app.header.menu.help.header');
    const feedback1: string = getMessage('app.header.menu.help.feedback1');
    const feedback2: string = getMessage('app.header.menu.help.feedback2');
    const feedback3: string = getMessage('app.header.menu.help.feedback3');
    const feedback4: string = getMessage('app.header.menu.help.feedback4');
    const feedback5: string = getMessage('app.header.menu.help.feedback5');
    const palceholderCommentBox: string = getMessage('app.header.menu.help.commentbox.placeholder');
    const cancelBtn: string = getMessage('app.header.menu.help.button.cancel');
    const submitBtn: string = getMessage('app.header.menu.help.button.submit');
    const retryBtn: string = getMessage('app.header.menu.help.button.retry');
    const loadingBtn: string = getMessage('app.header.menu.help.button.loading');

    /** Saves user feedback */
    const submitFeedback = async () => {
        setSubmitStatus('loading');
        let feedbackBody: IFeedbackAPIModel = {} as IFeedbackAPIModel;
        let result:number[] = [];
        Object.values(feedback).forEach((item, index) => item ? result.push(index) : null);
        feedbackBody.reason =result.length > 0 ? result.map((value:number)=>  FEEDBACK_REASON[value]).join(','): '';
        feedbackBody.feedback = remarks;
        await axios.post<void>(PROFILES_API_PATHS.feedback, feedbackBody).then(() => {
            setSubmitStatus('finished'); 
            props.onClose(true);
        }).catch((error) => {
            console.log('feedback error ', error);
            setSubmitStatus('error');
        });
    }

    const validateAndSetString = (value: string) => {
        if(checkSpecialCharacters(value)) 
            setValidationError(true);
        else {
            setValidationError(false);
            setRemarks(value)
        }
        
    }

    return (
        <Card className="feedback-card">
            {submitStatus !== 'loading' && <span className="close-icon" data-testid='fc-close-icon' onClick={() => props.onClose()}><Icon name="close" root="global" exactSize={24} /></span>}
            <Card.Header title={feedbackTitle} />
            <Card.Content>
            <Checkbox
                className='checkbox-fi'
                data-testid='cb-reason1'
                label={feedback1}
                checked={feedback.val1}
                onChange={(checked) => setFeedback({ ...feedback, 'val1': checked })}
            />
            <Checkbox
                className='checkbox-fi'
                data-testid='cb-reason2'
                label={feedback2}
                checked={feedback.val2}
                onChange={(checked) => setFeedback({ ...feedback, 'val2': checked })}
            />
            <Checkbox
                className='checkbox-fi'
                data-testid='cb-reason3'
                label={feedback3}
                checked={feedback.val3}
                onChange={(checked) => setFeedback({ ...feedback, 'val3': checked })}
            />
            <Checkbox
                className='checkbox-fi'
                data-testid='cb-reason4'
                label={feedback4}
                checked={feedback.val4}
                onChange={(checked) => setFeedback({ ...feedback, 'val4': checked })}
            />
            <Checkbox
                className='checkbox-fi'
                data-testid='cb-reason5'
                label={feedback5}
                checked={feedback.val5}
                onChange={(checked) => setFeedback({ ...feedback, 'val5': checked })}
            />
            <TextArea 
                className='textarea-fi'
                fluid={true} 
                rows={3} 
                placeholder={palceholderCommentBox} 
                onChange={(val) => validateAndSetString(val)} 
                value={remarks.trimStart()}
            />
            </Card.Content>
            {validationError && <div className="has_script">{HAS_SCRIPT}</div>}
            <Card.Footer>
                {submitStatus === 'error' && 
                    <div className="feedback-card-footer--err">
                        {ERROR_MSG_FOR_USER_RESPONSE}
                    </div>
                }
                <Button className="button--secondary custom-btn" 
                    size="small" type="secondary" 
                    disabled={submitStatus === 'loading'} 
                    onClick={() => {setFeedback(initialFeedbackStatus); props.onClose(); }} 
                    content={cancelBtn} 
                />
                <Button className={`button--primary ${submitStatus === 'loading' ?"feedback-card-footer--readonly btn-loading":""}`} 
                    icon={submitStatus === 'error' ?<Icon root="building"  
                    name="refresh" exactSize={22} className="feedback-card-footer--retry"/>:''} 
                    iconPosition="right" size="small" 
                    disabled={!(feedback.val1 || feedback.val2 || feedback.val3 || feedback.val4 || feedback.val5) || validationError || (feedback.val5 && remarks.trimStart().length <= 0)}  
                    data-testid='submit'
                    type="primary" 
                    onClick={() => { submitFeedback() }} 
                    content={submitStatus === 'loading' ? `${loadingBtn}` : submitStatus === 'error' ? `${retryBtn}` : `${submitBtn}` } 
                />
                
            </Card.Footer>
        </Card>
    );
}

export default FeedbackCard;